import { DealCard } from './DealCard'

export default DealCard
